import { render, staticRenderFns } from "./WelcomeAccountPage.vue?vue&type=template&id=5c6bdd28"
import script from "./WelcomeAccountPage.vue?vue&type=script&lang=js"
export * from "./WelcomeAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports